let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5qxMd")).then(() => parcelRequire('bRMFk'));